import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSignInLink } from "../../utils/path-helper";
import { useTranslation } from "react-i18next";

const SessionExpire = () => {
  const { locale } = useParams();
  const navigate = useNavigate();
  let signInLink = getSignInLink(locale, "");
  const { t } = useTranslation();
  useEffect(() => {
    signOutUser();
  }, []);
  const navigateSignIn = () => {
    navigate(signInLink);
  };

  const signOutUser = () => {
    localStorage.clear();
  };

  return (
    <div>
      <h2>
        Your session has been expired. Please login again -
        <button isLoading={false} disabled={false} onClick={navigateSignIn} classNames="btn btn-link px-2">
          {t("sign_up.sign_in")}{" "}
        </button>
      </h2>
    </div>
  );
};

export default SessionExpire;
